var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},_vm._l((_vm.computeNumber),function(item,index){return _c('p',{key:index,staticClass:"box-item"},[_c('span',{style:({ transform: 'translate(-50%,-' + item * 10 + '%)' })},[_vm._v("0123456789")])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b39d200","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/dashboard/china/numberScroll.vue
// module id = null
// module chunks = 